<template>
	<v-container fluid>
		<v-layout row wrap>
			<v-flex xs12>
				<span style="display:inline-block; padding:10px; margin-top:5px; color:grey; font-size:15px;"><b>{{$t('labels.reportsRealestate')}}</b></span><br><br>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex md3 xs12 offset-md1>
				<InputField
					v-model="realestate_id"
					:label="$t('fields.realestateId')"
					@keyup.native.enter="search"></InputField>
				<InputField
					v-model="type"
					:label="$t('fields.type')"
					@keyup.native.enter="search"></InputField>
				<InputField
					v-model="realestate_type"
					:label="$t('fields.realestateType')"
					@keyup.native.enter="search"></InputField>
				<InputField
					v-model="owner_name"
					:label="$t('fields.contactName')"
					@keyup.native.enter="search"></InputField>
			</v-flex>
			<v-flex md3 xs12 offset-md1>
				<InputField
					v-model="county"
					:label="$t('fields.county')"
					@keyup.native.enter="search"></InputField>
				<InputField
					v-model="city"
					:label="$t('fields.city')"
					@keyup.native.enter="search"></InputField>
				<InputField
					v-model="neighbourhood"
					:label="$t('fields.neighbourhood')"
					@keyup.native.enter="search"></InputField>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex md7 xs12 offset-md4>
				<v-btn color="grey lighten-1" @click="search">
					{{ $t('buttons.search') }}
				</v-btn>
			</v-flex>
			<v-flex md1 xs12 text-md-right text-xs-right>
				<v-tooltip bottom>
				<v-btn @click="excelExport" icon slot="activator">
					<v-icon small>fa-file-excel</v-icon>
				</v-btn>
				<span>{{$t('tooltips.excel')}}</span>
			</v-tooltip>
			</v-flex>
		</v-layout>
		<v-layout row wrap pt-3>
			<v-flex xs12>
				<DataTableContacts
						:excel="false"
						:filter="false"
						:headers="contactsTable.headers"
						:items="contactsTable.items"
						:total="contactsTable.total"
						@reload="reloadData"
						@excel="excelExport"
					>
						<template #row="props">
							<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
								<td @click="editClick(props.item.link, false)">{{ props.item.realestate_id }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.realestate_type }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.type }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.owner_name }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.county }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.city }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.neighbourhood }}</td>
							</tr>
						</template>
					</DataTableContacts>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import DataTableContacts from "./trinkets/DataTableContacts";
import InputField from "./trinkets/InputField";

export default {
	name: "ReportsRealestate",
	components: {DataTableContacts, InputField},
	data: function () {
		return {
			contactsTable: {
				headers: [
					{text: this.$t('fields.realestateId'), value: 'realestate_id', type: 'string', searchable: false},
					{text: this.$t('fields.realestateType'), value: 'realestate_type', type: 'string', searchable: false},
					{text: this.$t('fields.type'), value: 'type', type: 'string', searchable: false},
					{text: this.$t('fields.contactName'), value: 'owner_name', type: 'string', searchable: false},
					{text: this.$t('fields.county'), value: 'county', type: 'string', searchable: false},
					{text: this.$t('fields.city'), value: 'city', type: 'string', searchable: false},
					{text: this.$t('fields.neighbourhood'), value: 'neighbourhood', type: 'string', searchable: false},
				],
				items: [],
				total: 0,
				lastRequest: null
			},
			realestate_id: '',
			realestate_type: '',
			type: '',
			owner_name: '',
			county: '',
			city: '',
			neighbourhood: ''
		}
	},
	methods: {
		reloadData(request) {
			this.lastRequest = request;
			let vm = this;
			this.$APICall('get', 'report-realestate', request, (data, success) => {
				if (success) {
					vm.contactsTable.items = data.items;
					vm.contactsTable.total = data.total;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		excelExport() {
			if(this.contactsTable.items != undefined && this.contactsTable.items != null){
				if(this.contactsTable.items.length != 0){
					this.$APICall('post', 'excel/report-realestate', this.contactsTable.items, (data, success) => {
						window.open(data.link);
					});
				}
			}
		},
		contactReport(){
			this.$router.push('/reports/contacts');
		},
		search(){
			this.realestate_id = this.realestate_id.trim();
			this.type = this.type.trim();
			this.owner_name = this.owner_name.trim();
			this.county = this.county.trim();
			this.city = this.city.trim();
			this.neighbourhood = this.neighbourhood.trim();
			let data = {
				realestate_id: this.realestate_id,
				type: this.type,
				realestate_type: this.realestate_type,
				owner_name: this.owner_name,
				county: this.county,
				city: this.city,
				neighbourhood: this.neighbourhood,
			}
			this.reloadData(data);
		},
		editClick(link){
			if(link != null && link != ''){
				window.open(link);
			}
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.reports'), href: '/#/reports', disabled: true}
		]);
	}
}
</script>

<style scoped>

</style>
